<template>
  <div>
    <Jumbotron title="About Us" />

    <!-- desktop -->
    <b-container class="d-none d-sm-block text-justify p-3">
      <!-- navigation -->
      <b-row class="justify-content-center">
        <b-col cols="4">
          <b-row class="sg-about-us-menu">
            <b-col>
              <span :class="{ active: show_our_story }" @click="changeContent('our_story')">Our Story</span>
            </b-col>
            <b-col>
              <span :class="{ active: show_four_pillars }" @click="changeContent('four_pillars')">4 Pillars</span>
            </b-col>
            <!-- <b-col>
              <span :class="{ active: show_logo }" @click="changeContent('logo')">Logo</span>
            </b-col> -->
          </b-row>
        </b-col>
      </b-row>

      <!-- our story -->
      <transition name="fade">
        <b-row v-if="show_our_story" class="mt-3">
          <b-col>
            <p v-for="(text, index) in about_us" :key="index">
              {{ text }}
            </p>
          </b-col>

          <b-col class="center-base all">
            <b-img
            :src="require('@/assets/img/fullwidth/about-us.png')"
            class="about-us-img"
            />
          </b-col>
        </b-row>
      </transition>

      <!-- 4 pillars -->
      <transition name="fade">
        <b-row v-if="show_four_pillars" class="mt-3">
          <b-col>
            <b-row class="justify-content-center">
              <b-col cols="2" v-for="(four_pillar, index) in four_pillars" :key="index">
                <b-img
                  :src="require('@/assets/icon/four-pillars/' + four_pillar.icon)"
                  fluid
                />
              </b-col>
            </b-row>
            <b-row class="justify-content-center text-center">
              <b-col cols="2" v-for="(four_pillar, index) in four_pillars" :key="index">
                <h5>{{ four_pillar.text }}</h5>
              </b-col>
            </b-row>

            <b-row class="justify-content-center mt-3">
              <b-col cols="8" style="font-size: 18px;">
                <p>
                  StarGuides Telah membantu para mahasiswa/i di Eropa khususnya di Paris, Perancis.
                </p>
                <p>
                  Selain menggunakan jasa para mahasiswa atau Warga Negara Indonesia yang berada di luar Indonesia, StarGuides dapat membantu pemasukan untuk (khususnya) mahasiswa atau orang yang sedang membutuhkan pekerjaan di seluruh dunia nantinya.
                </p>
                <p>
                  Selain membantu para pelajar, StarGuides juga membantu para wisatawan yang ingin berkunjung ke negara yang berbeda budaya dan bahasa.
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </transition>

      <!-- logo -->
      <transition name="fade">
        <b-row v-if="show_logo" class="mt-3">
          <b-col>
            <b-row class="justify-content-center">
              <b-col cols="3">
                <b-img
                  :src="require('@/assets/img/logo.png')"
                  fluid
                />
              </b-col>
            </b-row>
            <b-row class="justify-content-center mt-3">
              <b-col cols="8" style="font-size: 18px;">
                <p>
                  Terinspirasi dari kapal layar,
                  siap mengarungi lautan luas,
                  siap menulis sejarah,
                  siap menjelajah dunia.

                </p>
                <p>
                  Kapal layar ini terdiri dari 1 dek kapal dan 2 layar kapal <br>
                  1. Dek Kapal: melambangkan perusahaan/aplikasi/produk <br>
                  2. Layar Bawah: melambangkan tim/creativitas/kerja keras <br>
                  3. Layar Atas: melambangkan visi/impian/cita-cita <br>
                </p>
                <p>
                  Tanpa ada layar, kapal ini tidak akan bisa melaju <br>
                  Tanpa dek kapal, maka kerja keras dan cita-cita tidak akan bisa menjadi nyata <br>
                  Begitu juga sebalik nya, tanpa ada layar kapal itu tidak akan bisa melaju <br>
                  Namun ketika semua itu menjadi satu, setiap rintangan yang menghalang akan bisa dihadapi
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </transition>

      <!-- visi -->
      <transition name="fade">
        <b-row class="d-none">
          <b-col>
            <p class="mt-5">
              <b>VISI</b>
            </p>

            <p class="mt-3">
              <ul>
                <li v-for="(text, index) in visi" :key="index">{{ text }}</li>
              </ul>
            </p>
          </b-col>
        </b-row>
      </transition>

      <!-- misi -->
      <transition name="fade">
        <b-row class="d-none">
          <b-col>
            <p class="mt-5">
              <b>MISI</b>
            </p>

            <p class="mt-3">
              <ul>
                <li v-for="(text, index) in misi" :key="index">{{ text }}</li>
              </ul>
            </p>
          </b-col>
        </b-row>
      </transition>

      <!-- value proposition -->
      <transition name="fade">
        <b-row class="d-none">
          <b-col>
            <b>VALUE PROPOSITION</b>

            <p>
              STARGUIDE adalah platform plat multi-sisi karena itu harus memiliki proposisi nilai untuk kedua belah pihak.
              <br>
              Keuntungan bagi Member dan Mitra :
              <ul>
                <li>Professional Relasi</li>
                <li>Edukasi</li>
                <li>Pengalaman </li>
                <li>Fun</li>
              </ul>
            </p>
          </b-col>
        </b-row>
      </transition>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none text-justify p-3">
      <!-- navigation -->
      <b-row class="justify-content-center">
        <b-col>
          <b-row class="sg-about-us-menu">
            <b-col>
              <span :class="{ active: show_our_story }" @click="changeContent('our_story')">Our Story</span>
            </b-col>
            <b-col>
              <span :class="{ active: show_four_pillars }" @click="changeContent('four_pillars')">4 Pillars</span>
            </b-col>
            <!-- <b-col>
              <span :class="{ active: show_logo }" @click="changeContent('logo')">Logo</span>
            </b-col> -->
          </b-row>
        </b-col>
      </b-row>

      <!-- our story -->
      <transition name="fade">
        <b-row v-if="show_our_story" class="mt-3">
          <b-col>
            <b-row>
              <b-col>
                <b-img
                  :src="require('@/assets/img/fullwidth/about-us.png')"
                  fluid
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p v-for="(text, index) in about_us" :key="index">
                  {{ text }}
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </transition>

      <!-- 4 pillars -->
      <transition name="fade">
        <b-row v-if="show_four_pillars" class="mt-3">
          <b-col>
            <b-row class="justify-content-center text-center">
              <b-col cols="8">
                <b-row>
                  <b-col cols="6" v-for="(four_pillar, index) in four_pillars" :key="index">
                    <b-row>
                      <b-col>
                        <b-img :src="require('@/assets/icon/four-pillars/' + four_pillar.icon)" fluid />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        {{ four_pillar.text }}
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="justify-content-center mt-3">
              <b-col cols="10" style="font-size: 16px;">
                <p>
                  StarGuides Telah membantu para mahasiswa/i di Eropa khususnya di Paris, Perancis.
                </p>
                <p>
                  Selain menggunakan jasa para mahasiswa atau Warga Negara Indonesia yang berada di luar Indonesia, StarGuides dapat membantu pemasukan untuk (khususnya) mahasiswa atau orang yang sedang membutuhkan pekerjaan di seluruh dunia nantinya.
                </p>
                <p>
                  Selain membantu para pelajar, StarGuides juga membantu para wisatawan yang ingin berkunjung ke negara yang berbeda budaya dan bahasa.
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </transition>

      <!-- logo -->
      <transition name="fade">
        <b-row v-if="show_logo" class="mt-3">
          <b-col>
            <b-row class="justify-content-center">
              <b-col cols="6">
                <b-img
                  :src="require('@/assets/img/logo.png')"
                  fluid
                />
              </b-col>
            </b-row>
            <b-row class="justify-content-center mt-3">
              <b-col cols="10" style="font-size: 18px;">
                <p>
                  Terinspirasi dari kapal layar,
                  siap mengarungi lautan luas,
                  siap menulis sejarah,
                  siap menjelajah dunia.

                </p>
                <p>
                  Kapal layar ini terdiri dari 1 dek kapal dan 2 layar kapal <br>
                  1. Dek Kapal: melambangkan perusahaan/aplikasi/produk <br>
                  2. Layar Bawah: melambangkan tim/creativitas/kerja keras <br>
                  3. Layar Atas: melambangkan visi/impian/cita-cita <br>
                </p>
                <p>
                  Tanpa ada layar, kapal ini tidak akan bisa melaju <br>
                  Tanpa dek kapal, maka kerja keras dan cita-cita tidak akan bisa menjadi nyata <br>
                  Begitu juga sebalik nya, tanpa ada layar kapal itu tidak akan bisa melaju <br>
                  Namun ketika semua itu menjadi satu, setiap rintangan yang menghalang akan bisa dihadapi
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </transition>
    </b-container>

    <b-container class="mt-5" />
  </div>
</template>

<script>
import Jumbotron from '@/components/Jumbotron'

export default {
  name: 'AboutUs',
  components: {
    Jumbotron
  },
  data () {
    return {
      show_our_story: true,
      show_four_pillars: false,
      show_logo: false,

      about_us: [
        'Berawal dari misi sosial, STARGUIDES kini telah tumbuh menjadi on-demand platform atau website terdepan yang menghubungkan Pelanggan dengan menggunakan jasa (khusus) para mahasiswa/i atau Orang Indonesia yang menyediakan berbagai layanan lengkap mulai dari transportasi dan lainnya. ',
        'Bukan hanya menawarkan benefit bagi para Travellers saja, Starguides juga tentunya mendatangkan benefit bagi para guide, khususnya mahasiswa/i Indonesia yang sedang menetap di luar negeri. Karena Starguides pastinya membantu para guide untuk mempunyai pemasukan tambahan, pengalaman dan koneksi!',
        'STARGUIDES adalah sebuah perusahaan teknologi berjiwa social bertujuan untuk meningkatkan kesejahteraan para pekerja khususnya mahasiswa yang sedang berada di luar Indonesia. STARGUIDES bertujuan pada 4 tumpu : kecepatan, pengetahuan, attitude dan dampak social.',
        'STARGUIDES telah membantu para mahasiswa/i di eropa khususnya berada di prancis lebih tepatnya di kota Paris. Selain menggunakan jasa para mahasiswa atau orang Indonesia yang berada di luar Indonesia, STARGUIDES dapat membantu pemasukan untuk (khususnya) mahasiswa atau orang yang sedang membutuhkan pekerjaan di seluruh dunia nantinya.',
        'Selain membantu para pelajar, STARGUIDES juga membantu para wisatawan jika ingin berkunjung ke negara yang berbeda budaya, dan Bahasa.'
      ],
      visi: [
        'Menjadi Applikasi guide PERTAMA di dunia.',
        'Menjadi aplikasi guide yang dibutuhkan seluruh dunia.',
        'Menjadi perusahaan guide untuk traveller yang mampu bersaing di penjuru dunia.',
        'Menjadi perusahaan penyedia jasa guide yang cepat dan sigap.',
        'Memberikan PRIVAT GUIDE dan PREMIUM GUIDE dengan harga yang sangat murah.'
      ],
      misi: [
        'Memberdayakan seluruh Masyarakat Indonesia yang ada di seluruh penjuru dunia.',
        'Membantu menambah pemasukan untuk seluruh masyarakat Indonesia diseluruh dunia khusus nya MAHASISWA/i.',
        'Mengajarkan para mahasiswa cara bekerja dibidang pelayanan.',
        'Mensejahterakan seluruh masyarakat Indonesia.'
      ],
      four_pillars: [
        {
          text: 'Kecepatan',
          icon: 'icon-01.png'
        },
        {
          text: 'Etika',
          icon: 'icon-02.png'
        },
        {
          text: 'Pengetahuan',
          icon: 'icon-03.png'
        },
        {
          text: 'Sosial',
          icon: 'icon-04.png'
        }
      ],
      logo: []
    }
  },
  methods: {
    changeContent: function (param) {
      this.show_our_story = this.show_four_pillars = this.show_logo = false

      setTimeout(() => {
        if (param === 'our_story') this.show_our_story = true
        if (param === 'four_pillars') this.show_four_pillars = true
        if (param === 'logo') this.show_logo = true
      }, 500)
    }
  }
}
</script>

<style scoped>
.about-us-img {
  width: 100%;
  height: auto;
}
.sg-about-us-menu {
  text-align: center;
  font-size: 20px;
}
.sg-about-us-menu > div > span {
  cursor: pointer;
}
.sg-about-us-menu > div > span.active {
  font-weight: 800;
  color: #233c7c;
  text-decoration: overline;
}

/* Fade Transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* END Fade Transition */
</style>



// WEBPACK FOOTER //
// src/views/Static/AboutUs.vue